var exports = {
  "e6": "AddFavoriteChannelModal.module__selectContainer___R3hRUV",
  "yc": "AddFavoriteChannelModal.module__checkboxRow___R3hRUV",
  "Dq": "AddFavoriteChannelModal.module__checkboxText___R3hRUV",
  "gs": "AddFavoriteChannelModal.module__scrollerContainer___R3hRUV",
  "o5": "AddFavoriteChannelModal.module__channelList___R3hRUV",
  "p$": "AddFavoriteChannelModal.module__emptyState___R3hRUV",
  "Km": "AddFavoriteChannelModal.module__categoryHeader___R3hRUV",
  "WG": "AddFavoriteChannelModal.module__channelRow___R3hRUV",
  "uM": "AddFavoriteChannelModal.module__channelIconContainer___R3hRUV",
  "p": "AddFavoriteChannelModal.module__channelIcon___R3hRUV",
  "HA": "AddFavoriteChannelModal.module__channelName___R3hRUV",
  "tN": "AddFavoriteChannelModal.module__channelActions___R3hRUV",
};

module.exports = exports;
